import { authStore } from '../../store/auth.store.js';
const RANK_ICONS = {
    1: '🥇',
    2: '🥈',
    3: '🥉',
};
const RANK_CLASSES = {
    1: 'gold',
    2: 'silver',
    3: 'bronze',
};
function formatDate(iso) {
    return new Date(iso).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}
export function createLeaderboardRow(member, rank, callbacks) {
    const isAdmin = authStore.canAdmin();
    const rankClass = RANK_CLASSES[rank] ?? '';
    const rankDisplay = RANK_ICONS[rank] ?? `#${rank}`;
    const row = document.createElement('div');
    row.className = `leaderboard-row ${rank <= 3 ? `rank-${rank}` : ''}`;
    row.dataset.memberId = member.id;
    row.innerHTML = `
    <div class="rank-badge ${rankClass}">${rankDisplay}</div>

    <div class="member-info">
      <span class="member-name">${escapeHtml(member.name)}</span>
      <span class="member-joined">Joined ${formatDate(member.created_at)}</span>
    </div>

    <div style="text-align:right">
      <div class="credits-value">${member.credits.toLocaleString()}</div>
      <div class="credits-label">Credits</div>
    </div>

    ${isAdmin
        ? `
      <div class="row-actions">
        <button class="btn-icon btn-edit" aria-label="Edit credits for ${escapeHtml(member.name)}" title="Edit credits">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
        </button>
        <button class="btn-icon btn-remove" aria-label="Remove ${escapeHtml(member.name)}" title="Remove member" style="color:var(--color-danger)">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
            <path d="M10 11v6"/><path d="M14 11v6"/>
          </svg>
        </button>
      </div>
    `
        : ''}
  `;
    if (isAdmin) {
        row
            .querySelector('.btn-edit')
            ?.addEventListener('click', (e) => {
            e.stopPropagation();
            callbacks.onEdit(member);
        });
        row
            .querySelector('.btn-remove')
            ?.addEventListener('click', (e) => {
            e.stopPropagation();
            callbacks.onRemove(member);
        });
    }
    return row;
}
function escapeHtml(str) {
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
